(() => {
  if (window.__attariyeBrandTitlesV2) return;
  window.__attariyeBrandTitlesV2 = true;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const titleRemainder = (fullTitle, brand) => {
    const full = normalize(fullTitle);
    const name = normalize(brand);
    if (!full || !name) return full;

    const fullLower = full.toLocaleLowerCase('tr-TR');
    const brandLower = name.toLocaleLowerCase('tr-TR');
    if (!fullLower.startsWith(brandLower)) return full;

    const nextCharacter = full.slice(name.length, name.length + 1);
    if (nextCharacter && !/[\s\-–—:]/.test(nextCharacter)) return full;

    return normalize(full.slice(name.length)).replace(/^[\-–—:]\s*/, '');
  };

  const makeBrandLink = (brand, brandUrl) => {
    const link = document.createElement('a');
    link.href = brandUrl;
    link.className = 'attariye-brand-link';
    link.textContent = brand;
    link.setAttribute('aria-label', `${brand} markasının tüm ürünlerini gör`);
    return link;
  };

  const enhanceCards = (root = document) => {
    root.querySelectorAll('.attariye-brand-card[data-attariye-brand]').forEach((wrapper) => {
      const brand = normalize(wrapper.dataset.attariyeBrand);
      const brandUrl = wrapper.dataset.attariyeBrandUrl;
      if (!brand || !brandUrl) return;

      wrapper.querySelectorAll('h3.card__heading > a.full-unstyled-link').forEach((productLink) => {
        if (productLink.dataset.attariyeBrandSplit === 'true') return;

        const fullTitle = normalize(productLink.textContent);
        const remainder = titleRemainder(fullTitle, brand);
        const brandLink = makeBrandLink(brand, brandUrl);

        productLink.dataset.attariyeBrandSplit = 'true';
        productLink.classList.add('attariye-product-title-link');
        productLink.textContent = remainder;
        productLink.before(brandLink);

        if (remainder) {
          brandLink.after(document.createTextNode(' '));
        } else {
          productLink.hidden = true;
        }
      });
    });
  };

  const enhanceProductTitles = (root = document) => {
    root.querySelectorAll('div.product__title').forEach((container) => {
      const h1 = container.querySelector(':scope > h1');
      if (!h1 || h1.dataset.attariyeBrandSplit === 'true') return;

      const directLinks = Array.from(container.children).filter((el) => el.matches && el.matches('a'));
      const vendorLink = directLinks.find((el) => el.getAttribute('href')?.includes('/collections/vendors'));
      if (!vendorLink) return;

      const brand = normalize(vendorLink.textContent);
      const brandUrl = vendorLink.getAttribute('href');
      if (!brand || !brandUrl) return;

      const fullTitle = normalize(h1.textContent);
      const remainder = titleRemainder(fullTitle, brand);
      const brandLink = makeBrandLink(brand, brandUrl);
      const text = document.createElement('span');
      text.className = 'attariye-product-title__text';
      text.textContent = remainder;

      h1.dataset.attariyeBrandSplit = 'true';
      h1.classList.add('attariye-product-title');
      h1.textContent = '';
      h1.append(brandLink);
      if (remainder) {
        h1.append(document.createTextNode(' '), text);
      }

      vendorLink.classList.add('attariye-brand-hidden');
      vendorLink.setAttribute('aria-hidden', 'true');
      vendorLink.setAttribute('tabindex', '-1');

      const duplicateTitleLink = directLinks.find((el) => el.classList.contains('product__title'));
      if (duplicateTitleLink) {
        duplicateTitleLink.classList.add('attariye-brand-hidden');
        duplicateTitleLink.setAttribute('aria-hidden', 'true');
        duplicateTitleLink.setAttribute('tabindex', '-1');
      }
    });
  };

  const enhance = (root = document) => {
    enhanceCards(root);
    enhanceProductTitles(root);
  };

  const run = () => enhance(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance(document);
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
